import {
  getLayoutMediaUrl,
  getLocalUriMediaUtil,
  getThumbnailUriMediaUtil,
  getUriMediaUtil
} from '../../../models/media/utils'
import isDownloadedFileSelector from '../../files/selectors/is-downloaded'
import { MEDIA_LAYOUT_TYPE } from '../../images/constants'
import { MEDIA_MODEL_KEY } from '../model'
import { MEDIA_PATH } from '../redux'
import { MESSAGE_KEY } from '../../message'
import getByIdReduxSelector from '../../redux/selectors/get-by-id'
import getCurrentReduxSelector from '../../redux/selectors/get-current'
import { getIdReduxUtil } from '../../redux/utils/get-id'
import getStatusReduxUtil from '../../redux/utils/get-status'
import { getValueReduxUtil } from '../../redux/utils/get-value'
import isLoadingReduxUtil from '../../redux/utils/is-loading'
import isSavingReduxUtil from '../../redux/utils/is-saving'
import { createSelector } from 'reselect'
import getFullUriFileSystemUtil from '../../../utils/file-system/get-full-uri'

export const getCurrentMediaSelect = getCurrentReduxSelector(MEDIA_PATH.DATA,
  MEDIA_PATH.CURRENT
)

export function getByIdMediaSelector (id) {
  return getByIdReduxSelector(MEDIA_PATH.DATA, id)
}

export const getCurrentIdMediaSelect = createSelector(getCurrentMediaSelect,
  instance => {
    return getIdReduxUtil(instance)
  }
)

export const getCurrentValueMediaSelect = createSelector(getCurrentMediaSelect,
  instance => {
    return getValueReduxUtil(instance, MESSAGE_KEY.VALUE)
  }
)
export const getCurrentReduxStatusMediaSelect = createSelector(getCurrentMediaSelect,
  instance => {
    return getStatusReduxUtil(instance)
  }
)

export const isCurrentPendingMediaSelect = createSelector(getCurrentMediaSelect,
  (instance) => {
    return (
      isLoadingReduxUtil(instance) || isSavingReduxUtil(instance)
    )
  }
)

export const getUriMediaSelector = ({
  id,
  layoutType
}) => createSelector(getByIdMediaSelector(id), (media) => {
  return getUriMediaUtil(media, layoutType)
})

export const getThumbnailUriMediaSelector = ({
  id,
  layoutType
}) => createSelector(getByIdMediaSelector(id), (media) => {
  return getThumbnailUriMediaUtil(media, layoutType)
})

export const getFullUriMediaSelector = ({
  id,
  layoutType
}) => createSelector(getByIdMediaSelector(id), (media) => {
  const localUri = getLocalUriMediaUtil(media)
  if (localUri) {
    return localUri
  }
  const uri = getUriMediaUtil(media, layoutType)
  if (!uri) {
    return
  }
  return getFullUriFileSystemUtil(uri)
})

export function isDownloadedByIdMediaSelector ({
  id,
  layoutType
}) {
  return state => {
    const media = getByIdMediaSelector(id)(state)
    if (!media) {
      return false
    }

    const localUri = getLocalUriMediaUtil(media)
    if (localUri) {
      return true
    }
    const uri = getUriMediaUtil(media, layoutType)
    return isDownloadedFileSelector(uri)(state)
  }
}

export function isThumbnailDownloadedMediaSelector ({
  id,
  layoutType
}) {
  return state => {
    const media = getByIdMediaSelector(id)(state)
    const uri = getThumbnailUriMediaUtil(media, layoutType)
    return isDownloadedFileSelector(uri)(state)
  }
}

export function getHeightMediaSelector (id) {
  return state => {
    const media = getByIdMediaSelector(id)(state)
    return getValueReduxUtil(media, MEDIA_MODEL_KEY.HEIGHT)
  }
}

export function getTypeMediaSelector (id) {
  return state => {
    const media = getByIdMediaSelector(id)(state)
    return getValueReduxUtil(media, MEDIA_MODEL_KEY.TYPE)
  }
}

export function getUrlMediaSelector ({
  id,
  layoutType
}) {
  return state => {
    const media = getByIdMediaSelector(id)(state)
    const type = getTypeMediaSelector(id)(state)
    return (
      getLayoutMediaUrl({
        url: getValueReduxUtil(media, MEDIA_MODEL_KEY.URL),
        layoutType,
        type
      })
    )
  }
}

export function getWidthMediaSelector (id) {
  return state => {
    const media = getByIdMediaSelector(id)(state)
    return getValueReduxUtil(media, MEDIA_MODEL_KEY.WIDTH)
  }
}

export const getFullUriThumbnailMediaSelector = ({
  layoutType = MEDIA_LAYOUT_TYPE.LARGE,
  id
}) => {
  return createSelector(getByIdMediaSelector(id), (media) => {
    const uri = getThumbnailUriMediaUtil(media, layoutType)
    if (!uri) {
      return
    }
    return getFullUriFileSystemUtil(uri)
  })
}
